import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af } from '../theme';

const styles = {
  title: css`
    margin-bottom: 6px;
  `,
  /**
   * `pre-line` so a body string can carry its own line breaks — the AI interview's "what you
   * need" checklist is part of the subtitle rather than a block of its own. Only wraps where
   * the copy says to; a body without newlines flows exactly as it did before.
   */
  body: css`
    margin-bottom: ${af.sp5};
    white-space: pre-line;
  `,
  /**
   * On the wrappers, not on the text. `ApplyText` renders an inline span, and an inline
   * box cannot be aligned by `text-align` — only the block around it can align what is
   * inside it.
   */
  centered: css`
    text-align: center;
  `,
  retry: css`
    margin-top: ${af.sp6};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
